<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn rounded text color="primary" :to="{name: 'FornecedoresLista'}" exact>
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      <!-- </v-toolbar-items> -->

      <template v-slot:actions>
        <v-btn
          text
          rounded
          :disabled="salvando"
          @click="$router.push({name: 'FornecedoresLista'})"
        >Cancelar</v-btn>
        <v-btn
          depressed
          rounded
          color="primary"
          :loading="salvando"
          :disabled="!form_valido"
          @click="confirmar"
          >Salvar</v-btn>
      </template>
    </z-centralized-toolbar>

    <z-container v-if="!$store.state.loading">
      <v-form ref="form" v-model="form_valido" lazy-validation>
        <!-- <h3 class="headline mb-3">{{ titulo }} Fornecedor</h3> -->

        <v-row>
          <v-col sm="12">
              <v-card class="mb-3">

                <v-card-title class="text-subtitle-2">
                  Dados do Fornecedor
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>

                  <v-row dense>
                    <v-col sm="12">
                      <v-text-field label="Razão Social" v-model="fornecedor.razao" :rules="regras.razao" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="12">
                      <v-text-field label="Nome Fantasia" v-model="fornecedor.fantasia" filled dense></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col sm="3">
                      <v-select :items="$globals.TIPO_PESSOA" label="Pessoa" v-model="fornecedor.tipo_pessoa" filled dense></v-select>
                    </v-col>
                    <v-col sm="3">
                      <z-cpf-cnpj label="CPF/CNPJ" v-model="fornecedor.cpfcnpj" filled dense></z-cpf-cnpj>
                    </v-col>
                    <v-col sm="3">
                      <v-text-field label="RG/Inscrição" v-model="fornecedor.rg_inscricao" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="3">
                      <v-text-field label="Nome de Contato" v-model="fornecedor.contato" filled dense></v-text-field>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
                
              <v-card class="mb-3">

                <v-card-title class="text-subtitle-2">
                  Endereço
                </v-card-title>

                <v-divider></v-divider> 
                <v-card-text>
                  <v-row dense>
                    <v-col sm="3">
                      <z-cep v-model="fornecedor.cep" buscarcep @resultado="preencherEndereco"></z-cep>
                    </v-col>
                    <v-col sm="6">
                        <v-text-field label="Endereço" v-model="fornecedor.endereco" @input="value => fornecedor.endereco = value.toUpperCase()" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="3">
                      <v-text-field ref="numero" label="Número" v-model="fornecedor.numero" filled dense></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col sm="5">
                      <v-text-field label="Bairro" v-model="fornecedor.bairro" @input="value => fornecedor.bairro = value.toUpperCase()" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="5">
                      <v-text-field label="Cidade" v-model="fornecedor.cidade"  @input="value => fornecedor.cidade = value.toUpperCase()" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="2">
                      <z-select :items="$globals.ESTADOS" label="Estado" v-model="fornecedor.estado"></z-select>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col sm="12">
                      <v-text-field label="Complemento" v-model="fornecedor.complemento" @input="value => fornecedor.complemento = value.toUpperCase()" filled dense></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col sm="3">
                        <v-text-field append-icon="mdi-whatsapp" label="Celular/Whatsapp" v-model="fornecedor.celular" v-mask="$globals.CELULAR_MASK" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="3">
                        <v-text-field label="Telefone" v-model="fornecedor.telefone" v-mask="$globals.TELEFONE_MASK" filled dense></v-text-field>
                    </v-col>
                    <v-col sm="6">
                        <v-text-field label="Email" :rules="regras.email" v-model="fornecedor.email" @input="value => fornecedor.email = value.toLowerCase()" required filled dense></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- <v-row dense>
                    <v-col sm="6">
                        <v-text-field label="Prazo" v-model="fornecedor.prazo" filled dense></v-text-field>
                    </v-col>
                  </v-row> -->

                </v-card-text>
              </v-card>

              <ContasChavesPix v-if="$store.state.fornecedores.fornecedor.id" :fornecedor="fornecedor" class="mb-3"></ContasChavesPix>

              <v-card  class="mb-3">
    
                <v-card-title class="text-subtitle-2">
                  Observações
                </v-card-title>
    
                <v-divider></v-divider> 
                <v-card-text>
                  <v-row dense>
                    <v-col sm="12">
                        <v-textarea label="Observações" placeholder="Observações sobre o  fornecedor" v-model="fornecedor.observacoes" filled dense></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
    
              </v-card>
          </v-col>
        </v-row>

      </v-form>
    </z-container>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import ContasChavesPix from "./ContasChavesPix.vue";

export default {
    name: 'fornecedores-form',
    components: {
      ContasChavesPix
    },
    data() {
        return {
          fornecedor: {
            tipo_pessoa: 'J',
            estado: 'PE',
            // limite_compra: 0
          },
          salvando: false,
          regras: {},
          tab: '',
          form_valido: false,
          regras: {
            razao: [v => !!v || 'É necessário preencher a Razão Social'],
          }
        };
    },

    beforeRouteLeave(to, from, next) {
      this.UNSET_FORNECEDOR();
      next();
    },

    async mounted() {
      this.setTitulo(this.titulo);
      if (this.$route.name == "FornecedoresEditar") {
        if (!this.$store.state.fornecedores.fornecedor.id) {
          if (this.$route.params.id) {
            await this.abrir(this.$route.params.id);
          }
        }
        this.fornecedor = this.clone(this.$store.state.fornecedores.fornecedor);
      }
    },

    methods: {
        ...mapMutations(["setTitulo"]),
        ...mapMutations("fornecedores", ["UNSET_FORNECEDOR"]),
        ...mapActions("fornecedores", ["abrir", "atualizar", "salvar"]),

        async confirmar() {
            try {
                this.salvando = true;

                if (this.$route.params.id) {
                    await this.atualizar(this.fornecedor);
                } else {
                    await this.salvar(this.fornecedor);
                }

                this.$router.push({ path: "/cadastros/fornecedores" });
                this.$eventbus.notificar("Fornecedor salvo com sucesso");
            } catch(error) {
              this.$eventbus.erro("Não foi possível salvar o fornecedor", error);
            } finally {
                this.salvando = false;
                
            }
        },

        preencherEndereco(endereco) {
            if (endereco.erro) {
                this.fornecedor.endereco = "";
                this.fornecedor.bairro = "";
                this.fornecedor.cidade = "";
                this.fornecedor.estado = "";
                // this.fornecedor.ibge  = '';
            } else {
                this.fornecedor.endereco = endereco.logradouro.toUpperCase();
                this.fornecedor.bairro = endereco.bairro.toUpperCase();
                this.fornecedor.cidade = endereco.localidade.toUpperCase();
                this.fornecedor.estado = endereco.uf.toUpperCase();
                // this.fornecedor.ibge  = endereco.ibge;
                this.$refs.numero.focus();
            }
        }
    },

    computed: {
      titulo() {
        let titulo = this.$route.meta.editando ? 'Editar' : 'Adicionar';
        return titulo + ' ' + 'Fornecedor';
      }
    },

    watch: {
        'fornecedor.cpfcnpj'(val, oldval){
          if (val) {
            this.fornecedor.tipo_pessoa = val.length > 14 ? 'J' : 'F';
          }
        }
    }
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */
</style>
